import { FC } from 'react';

type Props = {
	className?: string;
};

const PhoneIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M8.28976 5.10951L7.97658 4.40486C7.7718 3.94413 7.66942 3.71375 7.51629 3.53745C7.32439 3.31651 7.07425 3.15395 6.79442 3.06833C6.57112 3 6.31902 3 5.81483 3C5.07726 3 4.70848 3 4.3989 3.14178C4.03423 3.30879 3.7049 3.67144 3.57368 4.05047C3.46228 4.37223 3.4942 4.70289 3.558 5.36421C4.23726 12.4035 8.09652 16.2627 15.1358 16.942C15.7971 17.0058 16.1278 17.0377 16.4495 16.9263C16.8286 16.7951 17.1912 16.4657 17.3583 16.1011C17.5 15.7915 17.5 15.4227 17.5 14.6852C17.5 14.1809 17.5 13.9289 17.4317 13.7056C17.346 13.4257 17.1835 13.1756 16.9625 12.9837C16.7863 12.8306 16.5559 12.7282 16.0951 12.5234L15.3905 12.2102C14.8915 11.9885 14.642 11.8776 14.3885 11.8535C14.1459 11.8304 13.9013 11.8645 13.6742 11.9529C13.4369 12.0453 13.2272 12.2201 12.8076 12.5696C12.3901 12.9176 12.1814 13.0916 11.9263 13.1848C11.7001 13.2674 11.4011 13.298 11.1629 13.2629C10.8942 13.2233 10.6885 13.1134 10.277 12.8934C8.99676 12.2093 8.29074 11.5033 7.60656 10.223C7.38666 9.81155 7.27672 9.60575 7.23712 9.3371C7.20202 9.09887 7.23262 8.79989 7.31523 8.57379C7.40842 8.31866 7.58241 8.10989 7.93037 7.69233C8.27992 7.27286 8.45471 7.06313 8.54711 6.82582C8.63555 6.59873 8.66959 6.35409 8.64651 6.11148C8.6224 5.85796 8.51152 5.60848 8.28976 5.10951Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default PhoneIcon;
